import React from 'react';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';

import { makeStyles } from '@material-ui/core/styles';
import BarGaugeCard from './BarGaugeCard';
import PoweredByFN from './PoweredByFN';
import SliderBarCard from './SliderBarCard';

const useStyles = makeStyles({
  root: {
    maxWidth: '100%',
	marginTop: 20,
    paddingBottom: 30,
    paddingLeft: 20,
    paddingRight: 20,
    border: '1px solid #C8CCD1',
  },
  cardTitleText: {
    marginTop: 30,
    marginBottom: 10,
    color: '#333333',
    fontSize: 24,
    fontWeight: 600,
    letterSpacing: 0,
  },
  cardSubtitleText: {
    marginBottom: 40,
    fontSize: 16,
    color: '#333333',
  },
  poweredBy: {
	marginTop: 20
  }
});

function getIdealogySliderBar(politicalPositions) {
	const value = politicalPositions.ideologyScore.toFixed(2);
	return [{value: value, minLabel:"Very Liberal", maxLabel:"Conservative"}];
}

function getSponsorshipBar(politicalPositions) {
	return [{value: politicalPositions.sponsorshipPercentile, label:"Effectiveness", color:"#4DABB6"}];
}

function getCosponsorshipBar(politicalPositions) {
	return [{value: politicalPositions.cosponsorshipPercentile, label:"Effectiveness", color:"#4DABB6"}];
}

const PoliticalPositionsCard = (member = {}) => { 

	const classes = useStyles();

	if (undefined === member || 
		undefined === member.politicalPositions || 
		undefined === member.politicalPositions.ideologyScore) 
		{
			return null;
		}

	return (
		<Card className={classes.root} variant='outlined'>
			<div className={classes.cardTitleText}>Political Positions: Powered by FiscalNote AI</div>
			<div className={classes.cardSubtitleText}>
				How liberal or conservative a member tends to vote and their efficacy to get bills enacted as a primary sponsor and cosponsor.
			</div>
			<Grid container spacing={3}>
          		<Grid key="Ideology" item xs={12} sm={6} md={4}>
					<SliderBarCard 
						title="IDEOLOGY" 
						subTitle="How liberal or conservative a legislater tends to vote."
						min={-2.5}
						max={2.5}
						bars={getIdealogySliderBar(member.politicalPositions)}
					/>
          		</Grid>
				<Grid key="Sponsorship" item xs={12} sm={6} md={4}>
					<BarGaugeCard 
						title="SPONSORSHIP" 
						subTitle="A legislator's ability to get a bill enacted as the primary sponsor." 
						bars={getSponsorshipBar(member.politicalPositions)}
					/>
          		</Grid>
				<Grid key="Cosponsorship" item xs={12} sm={6} md={4}>
					<BarGaugeCard 
						title="COSPONSORSHIP" 
						subTitle="A legislator's ability to get a bill enacted as a cosponsor." 
						bars={getCosponsorshipBar(member.politicalPositions)}
					/>
          		</Grid>
        	</Grid>
			<div className={classes.poweredBy}>
				<PoweredByFN/>
			</div>		
		</Card>
	);
}

export default PoliticalPositionsCard;